import Meta from '@/components/common/Meta'

import LongTermStorageSolutionsPage from '@/v2/components/pages/landing-pages/long-term-storage-solutions-page'
import { LANDING_PAGES_META_CONTENTS } from '@/v2/constants/pages/landing-pages/meta/landing-pages-meta-content'
import { metaImages, ogImages } from '@/v2/constants/pages/landing-pages/long-term-storage-solutions-page'

interface LongTermStorageSolutionsPageProps {}

const Page: React.FC<LongTermStorageSolutionsPageProps> = () => {
  return (
    <>
      <Meta
        title={
          LANDING_PAGES_META_CONTENTS.long_term_storage_solutions.title ??
          LANDING_PAGES_META_CONTENTS.default?.title ??
          ''
        }
        keywords={
          LANDING_PAGES_META_CONTENTS.long_term_storage_solutions?.keywords ??
          LANDING_PAGES_META_CONTENTS.default?.keywords ??
          ''
        }
        description={
          LANDING_PAGES_META_CONTENTS.long_term_storage_solutions?.description ??
          LANDING_PAGES_META_CONTENTS.default?.description ??
          ''
        }
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
      />

      <LongTermStorageSolutionsPage />
    </>
  )
}

export default Page
